<template lang="pug">
	.tarea(@click="$emit('ver')")
		.icono
			span.fa.fa-camera(v-if="tarea.Fotografia == 'Si'")
			span.fa.fa-video-camera(v-if="tarea.Video == 'Si'")
		.contenido
			.titulo {{ tarea.Titulo }}
			.fechaCreacion
				span.fa.fa-calendar.mr-2
				span Creada el {{ new Date(tarea.FechaCreacionUnix * 1000) | moment('DD-MM-YYYY') }} a las {{ new Date(tarea.FechaCreacionUnix * 1000) | moment('HH:mm') }}
			.fechaEvento(v-if="tarea.FechaEvento")
				span.fa.fa-calendar-plus-o.mr-2
				span Evento el {{ tarea.FechaEvento | moment('DD-MM-YYYY') }} a las {{ tarea.FechaEvento | moment('HH:mm') }}
			.fechaPublicacion(:class="!tarea.FechaPublicacion ? 'danger' : ''")
				span.fa.fa-calendar-times-o.mr-2
				span(v-if="!tarea.FechaPublicacion") Publicación sin definir
				span(v-else) Publicación el {{ tarea.FechaPublicacion | moment('DD-MM-YYYY') }}
			.destinos
				span(
					v-for="destino in tarea.Destinos"
					:key="destino.DestinoID"
					:class="destino.Icono"
				)
		.avatar
			avatar(:usuario="tarea.UsuarioID")
			.nombre {{ tarea.UsuarioNombre }}
</template>

<script>
export default {
	props: ['tarea']
}
</script>


<style scoped>

.tarea:nth-child(odd) {
	background-color: #f9f9f9;
}
.tarea {
	position: relative;
	display: flex;
	flex-direction: row;
	width: 100%;
	cursor: pointer;
}

.tarea:hover {
	opacity: 0.7;
}

.tarea > .icono {
	width: 60px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 60px;
	align-self: center;
	text-align: center;
	font-size: 3em;
	color: #3D4553;
}

.tarea > .contenido {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	flex-shrink: 1;
	align-self: flex-start;
	text-align: left;
	font-size: 1em;
	padding: 10px;
}

.tarea > .contenido > .titulo {
	font-weight: bold;
	font-size: 1.2em;
}

.tarea > .contenido > .fechaCreacion {
	font-size: 0.9em;
	color: #444444;
}

.tarea > .contenido > .fechaEvento {
	font-size: 0.9em;
	color: #444444;
}

.tarea > .contenido > .fechaPublicacion {
	font-size: 0.9em;
	color: #444444;
}

.tarea > .contenido > .danger {
	color: darkred;
}

.tarea > .contenido > .destinos {
	margin-top: 15px;
}

.tarea > .contenido > .destinos > span {
	margin-right: 10px;
	font-size: 1.5em;
	opacity: 0.6;
}

.tarea > .avatar {
	width: 80px;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 80px;
	align-self: center;
	text-align: center;
	padding: 5px;
}

.tarea > .avatar > img {
	width: 60px;
	border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/overview/tarea.component.vue